/**
 * The key of a dashboard donut: one line per slice, its count and its share.
 *
 * The donuts carry no arc labels — in a card a third of the page wide, nivo's
 * link labels ran past the card's edge and were clipped ("ssagerie vocale").
 * Classification and Performance both name their slices here instead.
 */
export function PieLegend({
  data,
  total,
}: {
  data: { id: string; label: string; value: number; color: string }[];
  total: number;
}) {
  const share = (value: number) =>
    total > 0 ? Math.round((value / total) * 100) : 0;
  return (
    <ul className="space-y-1.5">
      {data.map((datum) => (
        <li key={datum.id} className="flex min-w-0 items-center gap-2 text-sm">
          <span
            className="h-2.5 w-2.5 shrink-0 rounded-full"
            style={{ backgroundColor: datum.color }}
          />
          <span className="truncate text-muted-foreground" title={datum.label}>
            {datum.label}
          </span>
          <span className="ml-auto shrink-0 font-medium tabular-nums">
            {datum.value}
          </span>
          <span className="w-10 shrink-0 text-right text-xs tabular-nums text-muted-foreground">
            {share(datum.value)}%
          </span>
        </li>
      ))}
    </ul>
  );
}
